const paginationHelper = (top = 0) => {
    window.scrollTo({
        top,
        behavior: 'instant',
    });
};

export default paginationHelper;